import { accessAutoThumb, accesscontrollerThumb, accessLiteThumb, deadboltThumb, emlockThumb } from '@assets/images/main/access/product';
import {
  accessKey1,
  accessOutlook,
  IconBattery,
  IconBluetooth,
  IconBox,
  IconComputer,
  IconCard,
  IconFacetime,
  IconGuarantee,
  IconQR,
  IconTemp,
  IconUsbc,
  IconWarn,
  IconWaterproof,
  IconCamera,
  IconZoom,
  IconTopology,
  IconEhternet,
  IconRoute2,
  IconUserCheck2,
  IconSearchGray,
  IconEnergyCircleGray,
  IconLinkChainGray,
} from '@assets/images/main/index';
import { bell1, esl1, idCard1, mCradle1, mCradleThumb, mTagThumb, switch1 } from '@assets/images/main/iot/product';
import {
  aoaEnterpriseKitThumb,
  aoaStarterKitThumb,
  assetTracking2,
  bleEnterpriseKit,
  bleStarterKit,
  bleStarterKit2,
  bleStarterKit3,
  comfortKitThumb,
  tagUwb1,
  twinTracker6,
  twinTrackerAoa1,
  twinTrackerAoa3,
  twinTrackerAoaThumb,
  twinTrackerBracket,
  uwbEnterpriseKitThumb,
  uwbStarterKitThumb,
} from '@assets/images/main/rtls/product';
import {
  IconAnalytics,
  IconAnalyticsGray,
  IconAppsLineGray,
  IconAtomGray,
  IconBinocularsGray,
  IconCar,
  IconCarGray,
  IconChainLink,
  IconChainLinkGray,
  IconCheck,
  IconCheckBlack,
  IconCodeGray,
  IconEnergyCircle,
  IconEyeline,
  IconInfo,
  IconLayerGray,
  IconLocation,
  IconLocationGray,
  IconMail,
  IconMonitorLineGray,
  IconPhone,
  IconPower,
  IconRoom,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSignal,
  IconSunGray,
  IconThumbUp,
  IconTools,
  IconToolsGray,
  IconTvocGray,
  IconUserCheck,
  IconUwbGray,
  IconWifi,
  IconZoneGray,
} from '@assets/images/icon';
import {
  accessKeyThumbnail,
  accessproThumbnail,
  deadboltThumbnail,
  emlockThumbnail,
  eslThumbnail,
  orbroServerThumbnail,
  safetyBellThumbnail,
  switchThumbnail,
  twinTrackerThumbnail,
} from '@assets/images/main/thumbnail';
import { enterpriseKit1, ipCamReverse, ipThumb, ptzThumb, starterKit2, starterKit3, starterKit4 } from '@assets/images/main/camera';
import { airQuality1, coMeasure1, loraGateway1, loraSensor1 } from '@assets/images/main/sensor';
import { coinTagThumb, orbroTag1, orbroTagThumb, plutoconPro1, plutoconProThumb, slimTagThumb, stickerTagThumb } from '@assets/images/main/beacon/product';
import { assetTag1 } from '@assets/images/main/beacon/product';
import { cobot1, deliverPackage, deliverRobot1, disinfection1, disinfection2, loadingKiosk1, loadingKiosk2 } from '@assets/images/main/integration';
import { IconCctvOff, IconCctvOn } from '@assets/images/main/icon';
import { vehicleTrackingKitThumb, yardTrackingKitThumb } from '@assets/images/main/outdoor';
import { osServer1 } from '@assets/images/main/os/product';

export default {
  purchaseDesc: {
    auto: 'Access Auto là sản phẩm chuyên biệt dành cho cửa tự động. Bằng cách thay thế cảm biến hiện có và cài đặt ứng dụng di động, sản phẩm cho phép ra vào không cần chạm.',
    face: 'Access Pro là sản phẩm tiên tiến, được thiết kế để điều khiển và gọi cửa tại các sảnh chung của tòa nhà. Với sản phẩm này, bạn có thể gọi người dùng và thực hiện cuộc gọi video thời gian thực qua ứng dụng di động, đồng thời điều khiển cửa ra vào từ xa. Hỗ trợ Ra vào bằng thẻ NFC và mật khẩu, Access Pro là giải pháp thay thế hoàn hảo cho các bộ điều khiển sảnh chung truyền thống, mang lại sự tiện lợi và bảo mật tối ưu.',
    accessory: '',

    asset: 'Gắn thiết bị tag BLE lên tài sản hoặc đối tượng cần theo dõi để định vị v',
    worker: 'Gắn thiết bị tag UWB lên tài sản hoặc đối tượng cần theo dõi để định v',

    osServer:
      'ORBRO Server là máy chủ tích hợp sẵn ORBRO OS, cung cấp chức năng theo dõi vị trí trong nhà và ghi lại lịch sử di chuyển, đồng thời hỗ trợ xử lý dữ liệu ổn định với tốc độ phản hồi nhanh.',
    osRtls:
      'ORBRO Edge RTLS là thiết bị dạng để bàn nhỏ gọn, hỗ trợ kết nối mạng tốc độ cao 1GbE. Sản phẩm cung cấp tính năng theo dõi vị trí nâng cao sử dụng thuật toán TDoA của ORBRO, mang lại hiệu suất định vị chính xác trong thời gian thực.',
    osAi: 'Giải pháp thông minh sử dụng hình ảnh từ camera để cung cấp chức năng theo dõi vị trí và đếm người (People Counting). Hệ thống có thể kết nối thông qua RTSP hoặc PoE để truyền dữ liệu hình ảnh, và đặc biệt có thể hoạt động độc lập mà không cần ORBRO Server.',
    osSwitch:
      'L2 Switch Hub là thiết bị chuyển mạch chuyên dụng của ORBRO, hỗ trợ 8 cổng kết nối với tốc độ tải lên 1Gbps. Thiết bị cung cấp nguồn PoE công suất 40W và hỗ trợ giám sát, quản lý trạng thái các thiết bị kết nối thông qua ứng dụng hoặc trình duyệt web.',

    server: 'Bộ kit server cấp doanh nghiệp với phân tích video AI, hỗ trợ theo dõi vị trí và nhận diện bối cảnh quy mô lớn.',
    edge: 'Giải pháp thông minh sử dụng hình ảnh camera để định vị và đếm người, kết nối qua RTSP hoặc PoE, hoạt động độc lập mà không cần máy chủ ORBRO.',

    ble: 'Có thể theo dõi vị trí bằng cách gắn thiết bị thẻ BLE lên tài sản hoặc đối tượng cần giám sát.',
    aoa: 'TwinTracker AoA là thiết bị Anchor cố định sử dụng công nghệ AoA (Angle of Arrival), hỗ trợ theo dõi vị trí không gian trong nhà với độ chính xác cao.',
    uwb: 'Có thể theo dõi vị trí bằng cách gắn thiết bị thẻ UWB lên tài sản hoặc đối tượng cần giám sát.',
    comfort:
      'Đây là bộ thiết bị định vị di động, có thể gắn lên người hoặc tài sản cần theo dõi vị trí theo thời gian thực qua thiết bị di động, mà không cần cơ sở hạ tầng riêng biệt.',

    gps: 'Vehicle Tracking Kit là thiết bị đầu cuối GPS hiệu suất cao, có khả năng định vị bằng GNSS, với độ chính xác sai số tối đa chỉ ±3 mét, tốc độ truyền dữ liệu lên tới 10 lần mỗi phút, hỗ trợ cổng USB-C và thời gian sử dụng lên tới 150 ngày.',
    lora: 'Yard Tracking Kit là bộ thiết bị sử dụng ngoài trời, thu nhận tín hiệu LoRa từ thẻ định vị GNSS trong khu vực rộng lớn, và liên kết dữ liệu này theo thời gian thực tới máy chủ ORBRO thông qua kết nối PoE.',

    monitoring: 'Safety Bell là sản phẩm có thể dễ dàng gắn, lắp đặt và sử dụng ngay ở bất kỳ đâu có Wi-Fi mà không bị giới hạn về địa điểm.',
    energy: 'Smart Switch cho phép thay thế công tắc analog thành digital một cách dễ dàng.',
    display: 'ESL là thiết bị hiển thị dựa trên beacon, sử dụng E-ink Display nên tiêu thụ điện rất thấp.',
    cradle: 'Quản lý điện thoại không dây mà không cần dây cáp khóa.',
    idCard: 'Thẻ nhân viên dạng dây đeo cổ, tương thích cao trong các môi trường công nghiệp và dịch vụ, hoạt động với hệ thống RTLS và Bluetooth của ORBRO.',

    loraGateway: 'ALESS_GW là bộ trung tâm truyền thông không dây công nghiệp, thu thập dữ liệu từ các cảm biến và chuyển tiếp về máy chủ mạng.',
    loraSensor:
      'Sản phẩm tích hợp với nhiều loại cảm biến như cảm biến nhiệt độ, áp suất, rò rỉ nước, và cảm biến nhiệt độ/độ ẩm, để đo lường dữ liệu và truyền dữ liệu qua kết nối không dây.',
    airQuality:
      'Máy đo chất lượng không khí công nghiệp độ chính xác cao, tích hợp cảm biến đo bụi mịn, CO2, tổng hợp chất hữu cơ dễ bay hơi (TVOC), nhiệt độ, độ ẩm. Hiển thị giá trị đo theo thời gian thực trên màn hình và cho phép kết nối với hệ thống máy chủ qua cổng giao tiếp để kiểm tra dữ liệu.',
    coMeasure:
      'Máy đo khí CO và chất lượng không khí tích hợp cảm biến đo bụi mịn (PM1.0/PM2.5/PM4.0/PM10), nhiệt độ, và độ ẩm, cho phép thu thập dữ liệu thời gian thực.',

    beaconIndustry: 'Beacon công nghiệp, chống nước/bụi IP65, hỗ trợ lắp đặt ngoài trời và pin dùng đến 5 năm.',
    beaconTag: 'Thiết bị beacon nhỏ gọn có thể gắn ở bất cứ đâu.',
    assetTag: 'Tag Bluetooth siêu nhỏ cho quản lý tài sản.',

    robotBasic: 'Cấu hình sản phẩm tích hợp hệ thống theo dõi vị trí thời gian thực và hệ thống robot giao hàng.',
    robot: 'Cấu hình sản phẩm tích hợp hệ thống theo dõi vị trí thời gian thực và hệ thống robot giao hàng.',
  },

  purchase: {
    mobile: {
      accesscontroller: {
        icon: accessKey1,
        title: 'Access Controller',
        serial: 'KB-BK02',
        price: '50,000',

        note: [
          { text: 'Hỗ trợ tính năng ra vào không tiếp xúc bằng di động', icon: IconInfo },
          { text: 'Sử dụng phiên bản Bluetooth mới nhất', icon: IconBluetooth },
          { text: 'Kiểm soát cửa trong phạm vi 10m', icon: IconWarn },
          { text: 'Chuẩn chống nước/bụi IP65 (-10 ~ 40°C)', icon: IconWaterproof },
          { text: 'Tuổi thọ pin lên đến 5 năm', icon: IconBattery },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'EM Lock',
            price: '150,000',
            img: emlockThumb,
          },
          {
            title: 'Deadbolt',
            price: '150,000',
            img: deadboltThumb,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: accesscontrollerThumb,
            title: 'Access Controller',
            price: '50,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    auto: {
      accessauto: {
        icon: accessKey1,
        title: 'Access Auto',
        serial: 'OAC-AUBT5091',
        price: '450,000',

        note: [
          { text: 'Hỗ trợ tính năng ra vào không tiếp xúc bằng di động', icon: IconInfo },
          { text: 'Sử dụng phiên bản Bluetooth mới nhất', icon: IconBluetooth },
          { text: 'Quản lý ra vào chính xác trong phạm vi 2m', icon: IconWarn },
          { text: 'Nhiệt độ hoạt động 0 ~ 50°C', icon: IconTemp },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'EM Lock',
            price: '150,000',
            img: emlockThumb,
          },
          {
            title: 'Deadbolt',
            price: '150,000',
            img: deadboltThumb,
          },
        ],
        options: [],
        mark: '',

        mainProduct: [
          {
            img: accessAutoThumb,
            title: 'Access Auto',
            price: '450,000',
            min: 1,
            max: 999,
          },
        ],
      },
      apart: {
        icon: accessOutlook,
        title: 'Gói chung cư',
        serial: 'Access Auto 20 + Server 1',
        price: 'theo yêu cầu',

        note: [
          { text: 'Hỗ trợ tính năng ra vào không tiếp xúc bằng di động', icon: IconInfo },
          { text: 'Bao gồm ORBRO OS trong máy chủ ORBBRO Server', icon: IconComputer },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'EM Lock',
            price: '150,000',
            img: emlockThumb,
          },
          {
            title: 'Deadbolt',
            price: '150,000',
            img: deadboltThumb,
          },
        ],

        options: [],
        mark: '',

        mainProduct: [
          {
            img: orbroServerThumbnail,
            title: 'ORBRO Server',
            price: '2,000,000',
            min: 1,
            max: 999,
          },
          {
            img: accessAutoThumb,
            title: 'Access Auto',
            price: '450,000',
            min: 20,
            max: 999,
          },
        ],
      },
      cloud: {
        icon: accessOutlook,
        title: 'Access Auto (Cloud)',
        serial: 'OAC-AUBT5091',
        price: '29,000',
        priceSub: '/tháng',

        note: [
          { text: 'Hỗ trợ tính năng ra vào không tiếp xúc bằng di động', icon: IconInfo },
          { text: 'Sử dụng phiên bản Bluetooth mới nhất', icon: IconBluetooth },
          { text: 'Quản lý ra vào chính xác trong phạm vi 2m', icon: IconWarn },
          { text: 'Nhiệt độ hoạt động 0 ~ 50°C', icon: IconTemp },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],
        parts: [],
        options: [],
        mark: '1',

        mainProduct: [
          {
            img: accessAutoThumb,
            title: 'Access Auto (Cloud)',
            price: '29,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    // Ra vào nhận diện khuôn mặt
    lite: {
      accessLite: {
        title: 'Access Lite',
        serial: 'OAC-LGBT0001',
        price: '700,000',

        note: [
          { text: 'Hỗ trợ ra vào bằng điện thoại thông minh và thẻ NFC, dựa trên công nghệ NFC · BLE', icon: IconInfo },
          { text: 'Tích hợp đường truyền thông tin và nguồn điện qua PoE', icon: IconEhternet },
          { text: 'Hỗ trợ chức năng ra vào không tiếp xúc bằng di động ', icon: IconPhone },
          { text: 'Hỗ trợ tính năng ra vào bằng thẻ NFC', icon: IconCard },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Khóa điện từ (EM Lock)',
            price: '150,000',
            img: emlockThumb,
          },
          {
            title: 'Chốt khóa (Deadbolt)',
            price: '150,000',
            img: deadboltThumb,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: accessLiteThumb,
            title: 'Access Lite',
            price: '700,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    face: {
      accesspro: {
        title: 'Access Pro',
        serial: 'KSB-SL02',
        price: '2,000,000',

        note: [
          { text: 'Hỗ trợ chức năng ra vào không tiếp xúc bằng di động và gọi video', icon: IconInfo },
          { text: 'Sử dụng phiên bản Bluetooth mới nhất', icon: IconBluetooth },
          { text: 'Ra vào bằng thẻ NFC', icon: IconCard },
          { text: 'Gọi video cho khách truy cập', icon: IconFacetime },
          { text: 'Mở khóa bằng mã QR', icon: IconQR },
          { text: 'Nhiệt độ hoạt động từ 0 ~ 40°C', icon: IconTemp },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'EM Lock',
            price: '150,000',
            img: emlockThumb,
          },
          {
            title: 'Deadbolt',
            price: '150,000',
            img: deadboltThumb,
          },
          {
            title: 'Cảm biến cửa tự động trong nhà',
            price: '99,000',
            img: accessAutoThumb,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: accessproThumbnail,
            title: 'Access Pro',
            price: '2,000,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    accessory: {
      accesskey: {
        title: 'Access Key',
        serial: 'KSB-AKC01',
        price: '30,000',

        note: [
          { text: 'Hỗ trợ chức năng ra vào không tiếp xúc sử dụng Beacon Key', icon: IconInfo },
          { text: 'Sử dụng phiên bản Bluetooth mới nhất', icon: IconBluetooth },
          { text: 'Sạc USB-C', icon: IconUsbc },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: ' ',

        mainProduct: [
          {
            img: accessKeyThumbnail,
            title: 'Access Key',
            price: '30,000',
            min: 1,
            max: 999,
          },
        ],
      },

      emlock: {
        title: 'EM Lock',
        serial: 'EM-Lock',
        price: '150,000',

        note: [
          {
            text: 'EM Lock là thiết bị khóa điện sử dụng lực từ để cố định cửa, chủ yếu được dùng cho cửa chống cháy, cửa gỗ và các loại cửa một chiều không phải cửa tự động.',
            icon: '',
          },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: ' ',

        mainProduct: [
          {
            img: emlockThumbnail,
            title: 'EM Lock',
            price: '150,000',
            min: 1,
            max: 999,
          },
        ],
      },

      deadbolt: {
        title: 'Deadbolt',
        serial: 'Deadbolt Lock',
        price: '150,000',
        note: [
          {
            text: 'Deadbolt là khóa chốt tự động có chức năng tự khóa khi đóng cửa. Nhờ vào khả năng tự động khóa, có thể sử dụng cho lối ra vào của căn hộ, văn phòng, cổng chính v.v…',
            icon: '',
          },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: ' ',

        mainProduct: [
          {
            img: deadboltThumbnail,
            title: 'Deadbolt',
            price: '150,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    ble: {
      twinTracker: {
        icon: twinTracker6,
        title: 'TwinTracker BLE',
        serial: 'OTR-TTBT0001',
        price: '400,000',

        note: [
          { text: 'Bluetooth Gateway hiệu suất cao', icon: IconInfo },
          { text: 'Quét tìm thiết bị Bluetooth 100 lần/giây', icon: IconSearchGray },
          { text: 'Hỗ trợ chức năng tìm thẻ Tag ở gần nhất', icon: IconBinocularsGray },
          { text: 'Hỗ trợ xuất dữ liệu đã thu thập qua cổng nối tiếp (Serial Output)', icon: IconQR },
          { text: 'Kết nối mạng thông qua Ethernet hoặc Wi-Fi', icon: IconChainLinkGray },
          { text: 'Hỗ trợ chuẩn PoE (Power over Ethernet)  ', icon: IconEnergyCircleGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Giá đỡ TwinTracker',
            price: '150,000',
            img: twinTrackerBracket,
          },
          {
            title: 'ORBRO Tag',
            price: '30,000',
            img: orbroTagThumb,
          },
          {
            title: 'Plutocon Tag',
            price: '150,000',
            img: plutoconProThumb,
          },
          {
            title: 'Coin Tag',
            price: '15,000',
            img: coinTagThumb,
          },
          {
            title: 'Slim Tag',
            price: '15,000',
            img: slimTagThumb,
          },
          {
            title: 'Sticker Tag',
            price: '15,000',
            img: stickerTagThumb,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: twinTracker6,
            title: 'TwinTracker BLE',
            price: '400,000',
            min: 1,
            max: 999,
          },
        ],
      },

      bleStarterKit: {
        icon: bleStarterKit,
        title: 'TwinTracker BLE Starter Kit',
        serial: 'ORBRO Edge RTLS x 1 + L2 Switch x 1 + TwinTracker BLE x 4',
        price: '2,500,000',

        note: [
          { text: 'Theo dõi vị trí thẻ BLE theo thời gian thực', icon: IconInfo },
          { text: 'Quét tìm thiết bị Bluetooth 100 lần/giây', icon: IconSearchGray },
          { text: 'Hỗ trợ chức năng tìm thẻ Tag ở gần nhất', icon: IconBinocularsGray },
          { text: 'ORBRO Edge RTLS 1 thiết bị có thể kết nối tối đa đến 8 thiết bị TwinTracker BLE', icon: IconEhternet },
          { text: 'Hỗ trợ xuất dữ liệu đã thu thập qua cổng nối tiếp (Serial Output)', icon: IconQR },
          { text: 'Kết nối mạng thông qua Ethernet hoặc Wi-Fi', icon: IconLinkChainGray },
          { text: 'Hỗ trợ chuẩn PoE (Power over Ethernet)  ', icon: IconEnergyCircleGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Giá đỡ TwinTracker',
            price: '150,000',
            img: twinTrackerBracket,
          },
          {
            title: 'ORBRO Tag',
            price: '30,000',
            img: orbroTagThumb,
          },
          {
            title: 'Plutocon Tag',
            price: '150,000',
            img: plutoconProThumb,
          },
          {
            title: 'Coin Tag',
            price: '15,000',
            img: coinTagThumb,
          },
          {
            title: 'Slim Tag',
            price: '15,000',
            img: slimTagThumb,
          },
          {
            title: 'Sticker Tag',
            price: '15,000',
            img: stickerTagThumb,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: twinTracker6,
            title: 'TwinTracker BLE Starter Kit',
            price: '2,500,000',
            min: 1,
            max: 999,
          },
        ],
      },

      bleEnterpriseKit: {
        icon: bleEnterpriseKit,
        title: 'TwinTracker BLE Enterprise Kit',
        serial: 'ORBRO Server x 1 + L2 Switch x 2 + ORBRO Edge RTLS x 2 + TwinTracker BLE x 12',
        price: '13,600,000',

        note: [
          { text: 'Hệ thống theo dõi vị trí BLE thời gian thực', icon: IconInfo },
          { text: 'Quét tìm thiết bị Bluetooth 100 lần/giây', icon: IconSearchGray },
          { text: 'Hỗ trợ chức năng tìm thẻ Tag ở gần nhất', icon: IconBinocularsGray },
          { text: 'ORBRO Edge RTLS 1 thiết bị có thể kết nối tối đa đến 8 thiết bị TwinTracker BLE', icon: IconEhternet },
          { text: 'Cấu hình mạng ổn định thông qua Switch L2', icon: IconEhternet },
          { text: 'Hỗ trợ xuất dữ liệu đã thu thập qua cổng nối tiếp (Serial Output)', icon: IconQR },
          { text: 'Kết nối mạng thông qua Ethernet hoặc Wi-Fi', icon: IconLinkChainGray },
          { text: 'Hỗ trợ chuẩn PoE (Power over Ethernet)  ', icon: IconEnergyCircleGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Giá đỡ TwinTracker',
            price: '150,000',
            img: twinTrackerBracket,
          },
          {
            title: 'ORBRO Tag',
            price: '30,000',
            img: orbroTagThumb,
          },
          {
            title: 'Plutocon Tag',
            price: '150,000',
            img: plutoconProThumb,
          },
          {
            title: 'Coin Tag',
            price: '15,000',
            img: coinTagThumb,
          },
          {
            title: 'Slim Tag',
            price: '15,000',
            img: slimTagThumb,
          },
          {
            title: 'Sticker Tag',
            price: '15,000',
            img: stickerTagThumb,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: bleStarterKit3,
            title: 'TwinTracker BLE Enterprise Kit',
            price: '13,600,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    aoa: {
      twinTrackerAoa: {
        icon: twinTrackerAoa3,
        title: 'TwinTracker AoA',
        serial: 'OTR-TTAO0001',
        price: '700,000',

        note: [
          { text: 'Theo dõi vị trí Bluetooth AoA', icon: IconInfo },
          { text: 'Quét tìm thiết bị Bluetooth 100 lần/giây', icon: IconSearchGray },
          { text: 'Hỗ trợ chức năng tìm thẻ Tag ở gần nhất', icon: IconBinocularsGray },
          { text: 'Hỗ trợ xuất dữ liệu đã thu thập qua cổng nối tiếp (Serial Output)', icon: IconQR },
          { text: 'Kết nối mạng thông qua Ethernet hoặc Wi-Fi', icon: IconChainLinkGray },
          { text: 'Hỗ trợ chuẩn PoE (Power over Ethernet)  ', icon: IconEnergyCircleGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Giá đỡ TwinTracker',
            price: '150,000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: twinTrackerAoaThumb,
            title: 'TwinTracker AoA',
            price: '700,000',
            min: 1,
            max: 999,
          },
        ],
      },

      aoaStarterKit: {
        icon: aoaStarterKitThumb,
        title: 'AoA Starter Kit',
        serial: 'ORBRO Edge RTLS x 1 + L2 Switch x 1 + TwinTracker AoA x 4',
        price: '3,700,000',

        note: [
          { text: 'Theo dõi vị trí thẻ AoA theo thời gian thực', icon: IconInfo },
          { text: 'Quét tìm thiết bị Bluetooth 100 lần/giây', icon: IconSearchGray },
          { text: 'Hỗ trợ chức năng tìm thẻ Tag ở gần nhất', icon: IconBinocularsGray },
          { text: 'ORBRO Edge RTLS 1 thiết bị có thể kết nối tối đa đến 8 thiết bị TwinTracker BLE', icon: IconEhternet },
          { text: 'Hỗ trợ xuất dữ liệu đã thu thập qua cổng nối tiếp (Serial Output)', icon: IconQR },
          { text: 'Kết nối mạng thông qua Ethernet hoặc Wi-Fi', icon: IconLinkChainGray },
          { text: 'Hỗ trợ chuẩn PoE (Power over Ethernet)  ', icon: IconEnergyCircleGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Giá đỡ TwinTracker Rail',
            price: '150,000',
            img: twinTrackerBracket,
          },
          {
            title: 'ORBRO AoA Tag',
            price: '40,000',
            img: orbroTagThumb,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: aoaStarterKitThumb,
            title: 'AoA Starter Kit',
            price: '3,700,000',
            min: 1,
            max: 999,
          },
        ],
      },

      aoaEnterpriseKit: {
        icon: aoaEnterpriseKitThumb,
        title: 'AoA Enterprise Kit',
        serial: 'ORBRO Server x 1 + L2 Switch x 2 + ORBRO Edge RTLS x 2 + TwinTracker BLE x 12',
        price: '17,200,000',

        note: [
          { text: 'Theo dõi vị trí thẻ AoA theo thời gian thực', icon: IconInfo },
          { text: 'Quét tìm thiết bị Bluetooth 100 lần/giây', icon: IconSearchGray },
          { text: 'Hỗ trợ chức năng tìm thẻ Tag ở gần nhất', icon: IconBinocularsGray },
          { text: 'ORBRO Edge RTLS 1 thiết bị có thể kết nối tối đa đến 8 thiết bị TwinTracker BLE', icon: IconEhternet },
          { text: 'Cấu hình mạng ổn định thông qua Switch L2', icon: IconEhternet },
          { text: 'Hỗ trợ xuất dữ liệu đã thu thập qua cổng nối tiếp (Serial Output)', icon: IconQR },
          { text: 'Kết nối mạng thông qua Ethernet hoặc Wi-Fi', icon: IconLinkChainGray },
          { text: 'Hỗ trợ chuẩn PoE (Power over Ethernet)  ', icon: IconEnergyCircleGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Giá đỡ TwinTracker Rail',
            price: '150,000',
            img: twinTrackerBracket,
          },
          {
            title: 'ORBRO AoA Tag',
            price: '40,000',
            img: orbroTagThumb,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: aoaEnterpriseKitThumb,
            title: 'AoA Enterprise Kit',
            price: '17,200,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    uwb: {
      twinTrackerUwb: {
        icon: twinTracker6,
        title: 'TwinTracker UWB',
        serial: 'OTR-TTUW0001',
        price: '600,000',

        note: [
          { text: 'Hỗ trợ định vị chính xác bằng thẻ UWB', icon: IconInfo },
          { text: 'Tương thích với thiết bị UWB Tag', icon: IconSearchGray },
          { text: 'Hỗ trợ chức năng tìm thẻ Tag ở gần nhất', icon: IconBinocularsGray },
          { text: 'Hỗ trợ xuất dữ liệu đã thu thập qua cổng nối tiếp (Serial Output)', icon: IconQR },
          { text: 'Kết nối mạng thông qua Ethernet hoặc Wi-Fi', icon: IconChainLinkGray },
          { text: 'Độ chính xác trong phạm vi dưới 1m, độ ổn định nhất quán trên 98% ', icon: IconRulerGray },
          { text: 'Hỗ trợ chuẩn PoE (Power over Ethernet)  ', icon: IconEnergyCircleGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'TwinTracker Rail Bracket',
            price: '150,000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: twinTracker6,
            title: 'TwinTracker UWB',
            price: '600,000',
            min: 1,
            max: 999,
          },
        ],
      },

      uwbStarterKit: {
        icon: uwbStarterKitThumb,
        title: 'TwinTracker UWB Starter Kit',
        serial: 'ORBRO Edge RTLS x 1 + L2 Switch x 1 + TwinTracker UWB x 4',
        price: '3,600,000',

        note: [
          { text: 'Hỗ trợ định vị chính xác bằng thẻ UWB', icon: IconInfo },
          { text: 'Tương thích với thiết bị UWB Tag', icon: IconSearchGray },
          { text: 'Hỗ trợ chức năng tìm thẻ Tag ở gần nhất', icon: IconBinocularsGray },
          { text: 'ORBRO Edge RTLS 1 thiết bị có thể kết nối tối đa đến 8 thiết bị TwinTracker UWB', icon: IconEhternet },
          { text: 'Hỗ trợ xuất dữ liệu đã thu thập qua cổng nối tiếp (Serial Output)', icon: IconQR },
          { text: 'Kết nối mạng thông qua Ethernet hoặc Wi-Fi', icon: IconLinkChainGray },
          { text: 'Độ chính xác trong phạm vi dưới 1m, độ ổn định nhất quán trên 98% ', icon: IconRulerGray },
          { text: 'Hỗ trợ chuẩn PoE (Power over Ethernet)  ', icon: IconEnergyCircleGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'TwinTracker Rail Bracket',
            price: '150,000',
            img: twinTrackerBracket,
          },
          {
            title: 'UWB Tag',
            price: '60,000',
            img: tagUwb1,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: uwbStarterKitThumb,
            title: 'TwinTracker UWB Starter Kit',
            price: '3,600,000',
            min: 1,
            max: 999,
          },
        ],
      },

      uwbEnterpriseKit: {
        icon: aoaEnterpriseKitThumb,
        title: 'TwinTracker UWB Enterprise Kit',
        serial: 'ORBRO Server x 1 + L2 Switch x 2 + ORBRO Edge RTLS x 2 + TwinTracker UWB x 12',
        price: '17,200,000',

        note: [
          { text: 'Hỗ trợ định vị chính xác bằng thẻ UWB', icon: IconInfo },
          { text: 'Tương thích với thiết bị UWB Tag', icon: IconSearchGray },
          { text: 'Hỗ trợ chức năng tìm thẻ Tag ở gần nhất', icon: IconBinocularsGray },
          { text: 'ORBRO Edge RTLS 1 thiết bị có thể kết nối tối đa đến 8 thiết bị TwinTracker UWB', icon: IconEhternet },
          { text: 'Cấu hình mạng ổn định thông qua Switch L2', icon: IconEhternet },
          { text: 'Hỗ trợ xuất dữ liệu đã thu thập qua cổng nối tiếp (Serial Output)', icon: IconQR },
          { text: 'Kết nối mạng thông qua Ethernet hoặc Wi-Fi', icon: IconLinkChainGray },
          { text: 'Độ chính xác trong phạm vi dưới 1m, độ ổn định nhất quán trên 98% ', icon: IconRulerGray },
          { text: 'Hỗ trợ chuẩn PoE (Power over Ethernet)  ', icon: IconEnergyCircleGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'TwinTracker Rail Bracket',
            price: '150,000',
            img: twinTrackerBracket,
          },
          {
            title: 'UWB Tag',
            price: '60,000',
            img: tagUwb1,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: uwbEnterpriseKitThumb,
            title: 'TwinTracker UWB Enterprise Kit',
            price: '17,200,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    comfort: {
      comfortKit: {
        icon: comfortKitThumb,
        title: 'Comfort Kit',
        serial: 'Mobile App x 1 + UWB Tag(Anchor) x 8 + UWB Tag(RTLS)',
        price: '990,000',

        note: [
          { text: 'Thiết bị định vị di động', icon: IconInfo },
          { text: 'Dễ dàng theo dõi vị trí ở bất cứ đâu', icon: IconSearchGray },
          { text: 'Hệ thống giám sát qua thiết bị di động', icon: IconPhone },
          { text: 'Có thể sử dụng mà không phân biệt giữa thiết bị Anchor hay Tag', icon: IconCheckBlack },
          { text: 'Độ chính xác trong phạm vi dưới 3m, độ ổn định nhất quán trên 98% ', icon: IconRulerGray },
          { text: 'Thời gian sử dụng khoảng 6 giờ', icon: IconEnergyCircleGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '0',

        mainProduct: [
          {
            img: comfortKitThumb,
            title: 'Comfort Kit',
            price: '990,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    gps: {
      gpsDevice: {
        icon: vehicleTrackingKitThumb,
        title: 'Vehicle Tracking Kit',
        serial: 'ORBRO Server x 1 + GPS Device x 5',
        price: '9,500,000',

        note: [
          { text: 'Thiết bị GNSS dành cho theo dõi tài sản và phương tiện ngoài trời', icon: IconInfo },
          { text: 'Truyền dữ liệu vị trí qua LTE-M', icon: IconUwbGray },
          { text: 'Độ chính xác vị trí trong phạm vi ±3m', icon: IconRulerGray },
          { text: 'Gửi dữ liệu vị trí tối đa 10 lần/phút (mỗi 6 giây)', icon: IconSignal },
          { text: 'Tùy chọn truyền thông BLE, NB-IoT', icon: IconSignal },
          { text: 'Tích hợp đèn LED hiển thị trạng thái', icon: IconSunGray },
          { text: 'Vỏ chống nước/chống bụi đạt chuẩn IP', icon: IconWaterproof },
          { text: 'Kiểu dáng gắn vào xe hoặc cầm tay', icon: IconCarGray },
          { text: 'Cổng sạc và dữ liệu USB Type-C', icon: IconEnergyCircleGray },
          { text: 'Hỗ trợ nhiều hệ thống vệ tinh (GPS, GLONASS, BeiDou)', icon: IconLocationGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: vehicleTrackingKitThumb,
            title: 'Vehicle Tracking Kit',
            price: '9,500,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    lora: {
      gpsTag: {
        icon: yardTrackingKitThumb,
        title: 'Yard Tracking Kit',
        serial: 'ORBRO Server x 1 + LoRa Gateway x 1 + GPS Tag(LoRA) x 10',
        price: '11,500,000',

        note: [
          { text: 'Giải pháp định vị ngoài trời dựa trên GNSS', icon: IconInfo },
          { text: 'Hỗ trợ truyền thông không dây LoRa lên đến 5km', icon: IconUwbGray },
          { text: 'Không cần LTE (giảm chi phí vận hành)', icon: IconUwbGray },
          { text: 'Độ chính xác định vị GNSS trong phạm vi ±3m', icon: IconRulerGray },
          { text: 'Vỏ chống nước/chống bụi đạt chuẩn IP', icon: IconWaterproof },
          { text: 'Thiết kế tối ưu cho các khu vực rộng lớn/cảng/công trường xây dựng', icon: IconRoom },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: yardTrackingKitThumb,
            title: 'Yard Tracking Kit',
            price: '11,500,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    worker: {
      workerTracking: {
        icon: accessKey1,
        title: 'Gói Định vị Người Lao Động',
        serial: 'TwinTrackerPro 10 + Server 1',
        price: '11,000,000',

        note: [
          { text: 'Định vị chính xác cao bằng UWB Tag', icon: IconInfo },
          { text: 'Độ chính xác trong 10cm', icon: IconWarn },
          { text: 'Lắp đặt trong nhà tối đa 600m²/gói', icon: IconRoom },
          { text: 'Lắp đặt ngoài trời tối đa 1,000m²/gói', icon: IconRoom },
          { text: 'Bao gồm ORBRO Server tích hợp ORBRO OS', icon: IconComputer },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Tag(UWB)',
            price: '60,000',
            img: tagUwb1,
          },
          {
            title: 'Giá đỡ TwinTracker',
            price: '150,000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: orbroServerThumbnail,
            title: 'ORBRO Server',
            price: '5,000,000',
            min: 1,
            max: 999,
          },
          {
            img: twinTrackerThumbnail,
            title: 'TwinTrackerPro',
            price: '600,000',
            min: 10,
            max: 30,
          },
        ],
      },
      twinTrackerPro: {
        icon: twinTrackerThumbnail,
        title: 'TwinTracker Pro',
        serial: 'OTR-TTUW0001',
        price: '600,000',

        note: [
          { text: 'Định vị bằng UWB Tag', icon: IconInfo },
          { text: 'Kết nối mạng Ethernet và Wi-Fi', icon: IconTopology },
          { text: 'Cung cấp PoE và USB-C', icon: IconPower },
          { text: 'Độ chính xác tối đa 10cm', icon: IconRulerGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Tag(UWB)',
            price: '60,000',
            img: tagUwb1,
          },
          {
            title: 'Giá đỡ TwinTracker',
            price: '150,000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: twinTrackerThumbnail,
            title: 'TwinTracker Pro',
            price: '600,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    server: {
      cameraEnterpriseKit: {
        icon: enterpriseKit1,
        title: 'ORBRO AI Server Enterprise Kit',
        serial: 'ORBRO AI Server x 1 + ORBRO Server',
        price: '19,000,000',

        note: [
          { text: 'Dịch vụ dựa trên vị trí cá nhân hóa qua video camera', icon: IconInfo },
          { text: 'Kết nối RTSP hoặc PoE cho dữ liệu video', icon: IconEhternet },
          { text: 'Hỗ trợ định vị tối đa 6 camera', icon: IconCctvOff },
          { text: 'Tích hợp với ORBRO Server', icon: IconRoute2 },
          { text: 'Cung cấp dịch vụ di động', icon: IconPhone },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Dome Camera',
            price: '1,600,000',
            img: ipCamReverse,
          },
          {
            img: ptzThumb,
            title: 'PTZ Camera',
            price: '4,000,000',
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: enterpriseKit1,
            title: 'ORBRO AI Server Enterprise Kit',
            price: '19,000,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    edge: {
      cameraStarterKit: {
        icon: accessKey1,
        title: 'ORBRO Edge AI Starter Kit',
        serial: 'ORBRO Edge AI x 1 + L2 Switch x 1',
        price: '1,000,000',

        note: [
          { text: 'Dịch vụ dựa trên vị trí cá nhân hóa qua video camera', icon: IconInfo },
          { text: 'Kết nối RTSP hoặc PoE cho dữ liệu video', icon: IconEhternet },
          { text: 'Hoạt động độc lập không cần server', icon: IconPhone },
          { text: 'Phân tích lưu lượng theo khung giờ', icon: IconRoute2 },
          { text: 'Tính năng đếm người', icon: IconUserCheck2 },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Dome Camera',
            price: '1,600,000',
            img: ipCamReverse,
          },
          {
            img: ptzThumb,
            title: 'PTZ Camera',
            price: '4,000,000',
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: starterKit2,
            title: 'ORBRO Edge AI Starter Kit',
            price: '1,000,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    osServer: {
      osServer: {
        icon: osServer1,
        title: 'ORBRO Server',
        serial: 'ONT-SVNO5001',
        price: '7,000,000',

        note: [
          { text: 'Máy chủ tích hợp sẵn hệ điều hành ORBRO OS', icon: IconInfo },
          { text: 'Hỗ trợ chức năng Trung tâm điều khiển', icon: IconEhternet },
          { text: 'Giao diện theo dõi vị trí theo thời gian thực', icon: IconLocationGray },
          { text: 'Hỗ trợ với nhiều nền tảng như iOS, iPadOS, macOS, Web, Android OS', icon: IconLayerGray },
          { text: 'Hỗ trợ ứng dụng phân tích dữ liệu vị trí', icon: IconCodeGray },
          { text: 'Cung cấp Developer Center', icon: IconGuarantee },
          { text: 'Bảo hành chất lượng 1 năm' },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: osServer1,
            title: 'ORBRO Server',
            price: '7,000,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    osRtls: {
      osRtls: {
        icon: starterKit2,
        title: 'ORBRO Edge RTLS',
        serial: 'ONT-ERWF0001',
        price: '800,000',

        note: [
          { text: 'Máy chủ tích hợp sẵn hệ điều hành ORBRO OS', icon: IconInfo },
          { text: 'Hỗ trợ 4 + 1 cổng kết nối', icon: IconEhternet },
          { text: 'Quản lý nguồn riêng cho từng cổng, có chức năng chống quá dòng', icon: IconEnergyCircleGray },
          { text: 'Giao diện mạng RJ45', icon: IconRoute2 },
          { text: 'Tích hợp chức năng đếm người (People Counting)', icon: IconUserCheck2 },
          { text: 'Hỗ trợ phân tích lưu lượng theo khung giờ', icon: IconAnalyticsGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: starterKit2,
            title: 'ORBRO Edge RTLS',
            price: '800,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    osAi: {
      osAi: {
        icon: enterpriseKit1,
        title: 'ORBRO Edge AI',
        serial: 'ONT-EAWF0001',
        price: '900,000',

        note: [
          { text: 'Cung cấp dịch vụ theo dõi vị trí dựa trên hình ảnh camera', icon: IconInfo },
          { text: 'Tích hợp dữ liệu hình ảnh qua RTSP hoặc PoE', icon: IconEhternet },
          { text: 'Hoạt động độc lập trên thiết bị di động, không cần ORBRO Server', icon: IconPhone },
          { text: 'Hỗ trợ phân tích lưu lượng ra vào theo khung giờ', icon: IconRoute2 },
          { text: 'Chức năng đếm người chính xác', icon: IconUserCheck2 },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: enterpriseKit1,
            title: 'ORBRO Edge AI',
            price: '900,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    osSwitch: {
      osSwitch: {
        icon: enterpriseKit1,
        title: 'L2 Switch',
        serial: 'ONT-LRBT5001',
        price: '100,000',

        note: [
          { text: 'Hub chuyển mạch L2 chuyên dụng cho sản phẩm ORBRO', icon: IconInfo },
          { text: 'Hỗ trợ 8 cổng kết nối', icon: IconEhternet },
          { text: 'Chống quá dòng, quản lý nguồn điện riêng cho từng cổng', icon: IconEnergyCircleGray },
          { text: 'Giao diện kết nối RJ45', icon: IconRoute2 },
          { text: 'Tốc độ tải lên 1Gbps', icon: IconPhone },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: starterKit4,
            title: 'L2 Switch',
            price: '100,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    monitoring: {
      safetyBell: {
        icon: bell1,
        title: 'Safety Bell',
        serial: 'KB-EW02',
        price: '100,000',

        note: [
          { text: 'Khi gặp tình huống khẩn cấp, người dùng chỉ cần nhấn nút, thiết bị sẽ gửi tin nhắn cảnh báo cho người quản lý', icon: IconInfo },
          { text: 'Hỗ trợ Bluetooth phiên bản mới nhất', icon: IconBluetooth },
          { text: 'Gửi tín hiệu cảnh báo thông qua kết nối Wi-Fi', icon: IconWifi },
          { text: 'Hỗ trợ gửi tối đa 100 tin nhắn cảnh báo', icon: IconMail },
          { text: 'Sử dụng pin AAA', icon: IconBattery },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '',

        mainProduct: [
          {
            img: safetyBellThumbnail,
            title: 'Safety Bell',
            price: '100,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    energy: {
      smartSwitch: {
        icon: switch1,
        title: 'Smart Switch',
        serial: 'KSB-SS01',
        price: '80,000',

        note: [
          { text: 'Công tắc thông minh điều khiển từ xa', icon: IconInfo },
          { text: 'Bluetooth 5.0', icon: IconBluetooth },
          { text: 'Điều khiển đèn qua app', icon: IconPhone },
          { text: 'Điều khiển chạm không tiếp xúc', icon: IconThumbUp },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '',

        mainProduct: [
          {
            img: switchThumbnail,
            title: 'Smart Switch',
            price: '80,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    display: {
      esl: {
        icon: esl1,
        title: 'ESL',
        serial: 'KI-MDE1',
        price: '80,000',

        note: [
          { text: 'Màn hình mực điện tử để hiển thị thông tin', icon: IconInfo },
          { text: 'Bluetooth 5.0', icon: IconBluetooth },
          { text: 'Cung cấp điện qua USB-C', icon: IconPower },
          { text: 'Độ phân giải 230dpi', icon: IconEyeline },
          { text: 'Hỗ trợ thẻ NFC', icon: IconSignal },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '',

        mainProduct: [
          {
            img: eslThumbnail,
            title: 'ESL',
            price: '80,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    cradle: {
      mTag: {
        icon: mTagThumb,
        title: 'Mobile Tag',
        serial: 'KI-MT02',
        price: '80,000',

        note: [
          { text: 'Thiết bị bảo mật không dây cho smartphone', icon: IconInfo },
          { text: 'Bluetooth 5.2', icon: IconBluetooth },
          { text: 'Tương thích iPhone, Android', icon: IconPhone },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        options: [
          { select: 'Lightning', imgIndex: 0 },
          { select: 'USB-C', imgIndex: 1 },
        ],

        parts: [],
        mark: '',

        mainProduct: [
          {
            img: mTagThumb,
            title: 'Mobile Tag',
            price: '80,000',
            min: 1,
            max: 999,
          },
        ],
      },

      mCradle: {
        icon: mCradle1,
        title: 'Mobile Cradle',
        serial: 'KI-MC02',
        price: '80,000',

        note: [
          { text: 'Thiết bị bảo mật không dây cho smartphone', icon: IconInfo },
          { text: 'Bluetooth 5.2', icon: IconBluetooth },
          { text: 'Sạc USB-C', icon: IconPhone },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '',

        mainProduct: [
          {
            img: mCradleThumb,
            title: 'Mobile Cradle',
            price: '80,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    idCard: {
      idCard: {
        icon: idCard1,
        title: 'ID02',
        serial: 'KB-ID02',
        price: '100,000',

        note: [
          { text: 'Thẻ nhân viên điện tử qua Bluetooth', icon: IconInfo },
          { text: 'Bluetooth 5.0', icon: IconBluetooth },
          { text: 'Cung cấp điện qua USB-C', icon: IconPower },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        options: [],
        parts: [],
        mark: '',

        mainProduct: [
          {
            img: idCard1,
            title: 'ID02',
            price: '100,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    loraGateway: {
      loraGateway: {
        icon: loraGateway1,
        title: 'LoRa Gateway',
        serial: 'ALESS-GW',
        price: '1,500,000',

        note: [
          { text: 'Thu thập dữ liệu từ các thiết bị cảm biến LoRa', icon: IconInfo },
          { text: 'Chống nước, chống bụi chuẩn IP67', icon: IconWaterproof },
          { text: 'Hoạt động ổn định trong môi trường tiêu chuẩn công nghiệp (-20 ~ 60°C)', icon: IconTemp },
          { text: 'Nguồn cung cấp 24VDC', icon: IconPower },
          { text: 'Khoảng cách truyền thông truyền thông truyền tối đa 6km', icon: IconWarn },
          { text: 'Hỗ trợ tối đa 150 cảm biến', icon: IconSignal },
          { text: 'Chọn kết nối LTE hoặc Wi-Fi', icon: IconWifi },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: loraGateway1,
            title: 'LoRa Gateway',
            price: '1,500,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    loraSensor: {
      loraSensor: {
        icon: loraSensor1,
        title: 'LoRa Sensor',
        serial: 'ALESS-BA',
        price: '450,000',

        note: [
          { text: 'Hỗ trợ kết nối với cảm biến đầu vào đa năng (Universal Input Sensor), tương thích với nhiều giao diện cảm biến', icon: IconInfo },
          { text: 'Chống nước, chống bụi chuẩn IP67', icon: IconWaterproof },
          { text: 'Hoạt động ổn định trong môi trường tiêu chuẩn công nghiệp (-20 ~ 60°C)', icon: IconTemp },
          { text: 'Hỗ trợ nguồn pin hoặc DC 24V bên ngoài.', icon: IconPower },
          { text: 'Khoảng cách truyền thông truyền thông truyền tối đa 6km', icon: IconWarn },
          { text: 'Tương thích với nhiều giao diện đầu vào', icon: IconChainLinkGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [
          { select: 'Chuông báo khẩn cấp', imgIndex: 10, price: '450,000' },
          { select: 'Phát hiện hỏa hoạn', imgIndex: 10, price: '600,000' },
          { select: 'Cảm biến nhiệt độ / độ ẩm', imgIndex: 10, price: '500,000' },
          { select: 'Cảm biến phát hiện rò rỉ nước nước', imgIndex: 10, price: '600,000' },
          { select: 'Áp suất chênh lệch', imgIndex: 10, price: '900,000' },
          { select: 'Phát hiện xâm nhập khu vực cấm', imgIndex: 10, price: '400,000' },
        ],

        mark: '2',

        mainProduct: [
          {
            img: loraSensor1,
            title: 'LoRa Sensor - Chuông báo khẩn cấp',
            price: '450,000',
            min: 1,
            max: 999,
          },
        ],
      },
      loraGateway: {
        icon: loraGateway1,
        title: 'LoRa Gateway',
        serial: 'ALESS-GW',
        price: '1,500,000',

        note: [
          { text: 'Thu thập dữ liệu từ các thiết bị cảm biến LoRa', icon: IconInfo },
          { text: 'Chống nước, chống bụi chuẩn IP67', icon: IconWaterproof },
          { text: 'Hoạt động ổn định trong môi trường tiêu chuẩn công nghiệp (-20 ~ 60°C)', icon: IconTemp },
          { text: 'Nguồn cung cấp 24VDC', icon: IconPower },
          { text: 'Khoảng cách truyền thông truyền thông truyền tối đa 6km', icon: IconWarn },
          { text: 'Hỗ trợ tối đa 150 cảm biến', icon: IconSignal },
          { text: 'Chọn kết nối LTE hoặc Wi-Fi', icon: IconWifi },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: loraGateway1,
            title: 'LoRa Gateway',
            price: '1,500,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    airQuality: {
      airQuality: {
        icon: airQuality1,
        title: 'Máy đo chất lượng không khí',
        serial: 'VENTAX',
        price: '800,000',

        note: [
          { text: 'Máy đo chất lượng không khí công nghiệp', icon: IconInfo },
          { text: 'Tích hợp màn hình hiển thị LCD màu', icon: IconMonitorLineGray },
          { text: 'Hỗ trợ kết nối RS-485 và LoRa', icon: IconSignal },
          { text: 'Chức năng tự làm sạch cảm biến (Auto Cleaning)', icon: IconToolsGray },
          { text: 'Được chứng nhận hạng 1 về đo bụi mịn bởi Cơ quan Môi trường Hàn Quốc', icon: IconAtomGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: airQuality1,
            title: 'Máy đo chất lượng không khí',
            price: '800,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    coMeasure: {
      coMeasure: {
        icon: coMeasure1,
        title: 'Máy đo CO (Carbon Monoxide)',
        serial: 'VENTAX co+',
        price: '1,500,000',

        note: [
          { text: 'Máy đo khí CO và chất lượng không khí', icon: IconInfo },
          { text: 'Hỗ trợ kết nối Wi-Fi và RS-485', icon: IconSignal },
          { text: 'Đo bụi mịn, CO₂, nhiệt độ và độ ẩm', icon: IconTvocGray },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '0',

        mainProduct: [
          {
            img: coMeasure1,
            title: 'Máy đo CO',
            price: '1,500,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    beaconIndustry: {
      plutoconPro: {
        icon: plutoconPro1,
        title: 'Plutocon Pro',
        serial: 'KB-BK02',
        price: '100,000',

        note: [
          { text: 'Thiết bị beacon công nghiệp', icon: IconInfo },
          { text: 'Sử dụng phiên bản Bluetooth mới nhất', icon: IconBluetooth },
          { text: 'Chuẩn chống nước/bụi IP65 (-10 ~ 60°C)', icon: IconWaterproof },
          { text: 'Tuổi thọ pin lên đến 5 năm', icon: IconBattery },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '0',

        mainProduct: [
          {
            img: plutoconPro1,
            title: 'Plutocon Pro',
            price: '100,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    beaconTag: {
      orbroTag: {
        icon: orbroTag1,
        title: 'ORBRO Tag',
        serial: 'OAS-OTBT1991',
        price: '30,000',

        note: [
          { text: 'Thiết bị beacon nhỏ gọn', icon: IconInfo },
          { text: 'Sử dụng phiên bản Bluetooth mới nhất', icon: IconBluetooth },
          { text: 'Chuẩn chống nước/bụi IP65 (-10 ~ 60°C)', icon: IconWaterproof },
          { text: 'Tuổi thọ pin lên đến 2 năm', icon: IconBattery },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '0',

        mainProduct: [
          {
            img: orbroTag1,
            title: 'ORBRO Tag',
            price: '30,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    assetTag: {
      assetTag: {
        icon: assetTag1,
        title: 'Asset Tag (1.000EA)',
        serial: 'OAS-ABBT1991',
        price: '20,000,000',

        note: [
          { text: 'Beacon siêu nhỏ cho quản lý tài sản', icon: IconInfo },
          { text: 'Sử dụng phiên bản Bluetooth mới nhất', icon: IconBluetooth },
          { text: 'Tuổi thọ pin lên đến 1 năm', icon: IconBattery },
          { text: 'Bảo hành chất lượng 1 năm', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: assetTag1,
            title: 'Asset Tag (1.000EA)',
            price: '20,000,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    robot: {
      robotBasic: {
        icon: deliverRobot1,
        title: 'Gói cơ bản robot giao hàng',
        serial: 'Delivery Robot + TwinTrackerPro 10 + Server 1',
        price: 'Liên hệ',

        note: [
          {
            text: 'Sự kết hợp giữa hệ thống định vị trong nhà và hệ thống robot, cấu hình đơn giản, dễ dàng triển khai, vận hành nhanh chóng.',
            icon: IconInfo,
          },
          { text: 'Dung tích chứa hàng của robot 20L', icon: IconBox },
          { text: 'Độ chính xác trong phạm vi 10cm', icon: IconRulerGray },
          { text: 'Hỗ trợ lắp đặt trong nhà lên đến 600m²', icon: IconRoom },
          { text: 'Hỗ trợ lắp đặt ngoài trời lên đến 1.000m²', icon: IconRoom },
          { text: 'Bao gồm ORBRO OS trong máy chủ ORBBRO Server', icon: IconComputer },
        ],

        parts: [
          {
            title: 'Tag (UWB)',
            price: '60,000',
            img: tagUwb1,
          },
          {
            title: 'Giá đỡ TwinTracker Rail',
            price: '150,000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: orbroServerThumbnail,
            title: 'ORBRO Server',
            price: '5,000,000',
            min: 1,
            max: 999,
          },
          {
            img: twinTrackerThumbnail,
            title: 'TwinTrackerPro',
            price: '600,000',
            min: 10,
            max: 30,
          },
          {
            img: deliverRobot1,
            title: 'Delivery Robot',
            price: 'Liên hệ',
            min: 1,
            max: 10,
          },
        ],
      },

      delivery: {
        icon: deliverPackage,
        title: 'Gói Tự động xếp/dỡ hàng không người lái',
        serial: 'Delivery Robot + Loa tích hợp tích hợpding Kiosk + Cobot + TwinTrackerPro 10 + Server 1',
        price: 'Liên hệ',

        note: [
          { text: 'Gói thiết bị giúp robot giao hàng có thể tự động thực hiện quy trình xếp/dỡ hàng mà không cần người điều khiển.', icon: IconInfo },
          { text: 'Dung tích chứa hàng của robot 20L', icon: IconBox },
          { text: 'Tải trọng tối đa của robot cộng tác 12kg', icon: IconBox },
          { text: 'Độ chính xác trong phạm vi 10cm', icon: IconRulerGray },
          { text: 'Hỗ trợ lắp đặt trong nhà lên đến 600m²', icon: IconRoom },
          { text: 'Hỗ trợ lắp đặt ngoài trời lên đến 1.000m²', icon: IconRoom },
          { text: 'Bao gồm ORBRO OS trong máy chủ ORBBRO Server', icon: IconComputer },
        ],

        parts: [
          {
            title: 'Tag (UWB)',
            price: '60.000',
            img: tagUwb1,
          },
          {
            title: 'Giá đỡ TwinTracker Rail',
            price: '150.000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: orbroServerThumbnail,
            title: 'ORBRO Server',
            price: '5.000.000',
            min: 1,
            max: 999,
          },
          {
            img: twinTrackerThumbnail,
            title: 'TwinTrackerPro',
            price: '600.000',
            min: 10,
            max: 30,
          },
          {
            img: deliverRobot1,
            title: 'Delivery Robot',
            price: 'Liên hệ',
            min: 1,
            max: 10,
          },
          {
            img: loadingKiosk2,
            title: 'Loa tích hợp tích hợpding Kiosk',
            price: 'Liên hệ',
            min: 1,
            max: 10,
          },
          {
            img: cobot1,
            title: 'Cobot',
            price: 'Liên hệ',
            min: 1,
            max: 10,
          },
        ],
      },

      disinfection: {
        icon: disinfection1,
        title: 'Gói Quản lý Rủi ro Cao',
        serial: 'Delivery Robot + Loa tích hợp tích hợpding Kiosk + Cobot + Disinfection Device + etc',
        price: 'Liên hệ',

        note: [
          { text: 'Gói cho phép quản lý vận chuyển thiết bị y tế nguy cơ cao với khử trùng', icon: IconInfo },
          { text: 'Dung tích chứa hàng của robot 20L', icon: IconBox },
          { text: 'Tải trọng tối đa của robot cộng tác 12kg', icon: IconBox },
          { text: 'Khử trùng và tiệt trùng 99.9%', icon: IconTvocGray },
          { text: 'Độ chính xác trong phạm vi 10cm', icon: IconRulerGray },
          { text: 'Hỗ trợ lắp đặt trong nhà lên đến 600m²', icon: IconRoom },
          { text: 'Hỗ trợ lắp đặt ngoài trời lên đến 1.000m²', icon: IconRoom },
          { text: 'Bao gồm ORBRO OS trong máy chủ ORBBRO Server', icon: IconComputer },
        ],

        parts: [
          {
            title: 'Tag (UWB)',
            price: '60.000',
            img: tagUwb1,
          },
          {
            title: 'Giá đỡ TwinTracker Rail',
            price: '150.000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: orbroServerThumbnail,
            title: 'ORBRO Server',
            price: '5.000.000',
            min: 1,
            max: 999,
          },
          {
            img: twinTrackerThumbnail,
            title: 'TwinTrackerPro',
            price: '600.000',
            min: 10,
            max: 30,
          },
          {
            img: deliverRobot1,
            title: 'Delivery Robot',
            price: 'Liên hệ',
            min: 1,
            max: 10,
          },
          {
            img: loadingKiosk2,
            title: 'Loa tích hợp tích hợpding Kiosk',
            price: 'Liên hệ',
            min: 1,
            max: 10,
          },
          {
            img: cobot1,
            title: 'Cobot',
            price: 'Liên hệ',
            min: 1,
            max: 10,
          },
          {
            img: disinfection2,
            title: 'Bộ thiết bị Khử trùng',
            price: 'Liên hệ',
            min: 1,
            max: 10,
          },
        ],
      },
    },
  },

  modal: {
    title: 'Liên hệ tư vấn sản phẩm',
    descHead: 'Vui lòng nhập thông tin vào các mục dưới đây, chúng tôi sẽ gửi báo giá cho Quý khách qua nhân viên phụ trách.',
    descMid: 'Nếu cần phản hồi nhanh, vui lòng liên hệ qua số',
    phone: '1522-9928.',
    descTail: 'Xin cảm ơn.',
    time: 'Giờ làm việc: các ngày trong tuần (10:00 - 19:00)',

    theme: {
      name: 'Họ tên *',
      company: 'Công ty *',
      email: 'Email công việc *',
      phone: 'Số điện thoại',
    },
    placeholder: {
      name: 'Nguyễn Văn A',
      company: 'Công ty ORBRO',
      email: 'example@orbro.io',
      phone: '090-1234-5678',
      ask: 'Vui lòng nhập các yêu cầu khác (Tùy chọn)',
    },
  },

  accessory: 'Phụ kiện',
  soldOut: 'Hết hàng',
  new: 'New',
  request: 'Liên hệ',
  select: 'Chọn',

  submit: 'Gửi',
  cancel: 'Hủy',
};
